import { Button } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";
import NewCreateIcon from "@mui/icons-material/AddCircleOutline";
import useLocales from "../../hooks/useLocales";

interface INewCreateButton {
  path?: string;
  pathname: string;
  onClick: any;
}

const styleButton = {
  boxShadow: "none",
  fontSize: 16,
  padding: "6px 12px",
  color: "#999999",
  border: "1px solid #D9D9D9",
  lineHeight: 1.5,
  position: "relative",
  height: "46px",
  fontWeight: "400",
  textDecoration: "none",
  textTransform: "none",
  "& span": {
    textDecoration: "none",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
  "&:hover": {
    background: "none",
    color: "#0033A1",
    "& svg": {
      color: "#0033A1",
    },
  },
};

const NewCreateButton: FC<INewCreateButton> = (props: any) => {
  const { path, pathname, onClick } = props;
  const { translate } = useLocales();

  return (
    <Link to={path ? path : pathname + "/create"} onClick={onClick}>
      <Button
        sx={styleButton}
        startIcon={<NewCreateIcon />}
        variant="outlined"
        fullWidth
      >
        {translate("actions.create")}
      </Button>
    </Link>
  );
};

export default NewCreateButton;
